import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import {
  applicationConfigurationFeatureKey,
  applicationConfigurationReducer,
} from './application-configuration.reducer';
import { EffectsModule } from '@ngrx/effects';
import { ApplicationConfigurationEffects } from './application-configuration.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(applicationConfigurationFeatureKey, applicationConfigurationReducer),
    EffectsModule.forFeature([ApplicationConfigurationEffects]),
  ],
})
export class ApplicationConfigurationStoreModule {}
